import { render } from "./TableGroup.vue?vue&type=template&id=02d0b46a&scoped=true"
import script from "./TableGroup.vue?vue&type=script&lang=js"
export * from "./TableGroup.vue?vue&type=script&lang=js"

import "./TableGroup.vue?vue&type=style&index=0&id=02d0b46a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d0b46a"]])

export default __exports__